<template>
  <div :style="cssVars" class="app">
    <Header @changeMenuViewState="changeMenuStateView" ></Header>
    <div class="main-container">
      <dropdown-menu :elements="elements" :isActive="isMenuActive"/>
      <main class="main-content">
        <router-view :key="$route.fullPath" />
      </main>
    </div>
  </div>
</template>

<script>
import { EventDriver } from '../utils/EventDriver';
import { getDashboardNameByRoute } from '../utils/dataValidation/dashboardNameByRoute'
import Header from './Header.vue'
import DropdownMenu from './DropdownMenu.vue'
export default {
  data() {
    return {
      isMenuActive: false,
      routes: [],
      viewerRole: 'visualizador',
      managerRole: 'gestionador',
      managerMenuElements: [
        {
          route: 'upload-files',
          content: 'Subida de archivos',
          logoName: 'mdi-tray-arrow-up'
        },
        {
          route: 'history',
          content: 'Historial de subidas',
          logoName: 'mdi-history'
        },
      ]
    }
  },
  components: {
    Header,
    DropdownMenu
  },
  computed: {
    elements () {
      if(this.$store.state.userData.role === this.managerRole) {
        return this.managerMenuElements
      } else {
        const organizerMenuElement = this.$store.state.views.map(view => {
          return {
              route: "dashboard/" + view.view,
              content: getDashboardNameByRoute(view.embedUrl) || "Dashboard",
              logoName: 'mdi-chart-tree'
            }
          })
          return organizerMenuElement
      }
    },
    cssVars() {
      return {
        '--principal-color': '#E5E5E5',
        '--secondary-color': '#008B52'
      }
    }
  },
  methods: {
    logOut() {
      EventDriver.$emit('logOut');
    },
    changeMenuStateView() {
      this.isMenuActive = !this.isMenuActive
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.app {
  height: 100%;
  width: 100%;
}
.main-container {
  display: flex;
  width: 100%;
  height: 93%;
  justify-content: space-evenly;
}
.unactive {
  transition: display 3s;
  display: none;
}
main {
  width: 85%;
  height: 100%;
}
.main-content {
  flex-grow: 2; 
}
</style>